export const vars = {
    colors: {
        primary: {
            '500': '#060A2D'
        },
        secondary: {
            '100': '#00229E',
            '300': '#1600CC',
            '500': '#0080FF',
            '600': '#DAEDFF',
            '700': '#F1F2F4',
            '800': '#F6FAFF',
            '900': '#DAEAF5',
        },
        natural: {
            '100': '#000000',
            '150': '#363636',
            '200': '#999999',
            '250': '#8E98A8',
            '300': '#909090',
            '400': '#DADFE5',
            '450': '#ECEBED',
            '500': '#F3F3F3',
            '600': '#FBFBFB',
            '700': '#DCDCDC',
            '900': '#FFFFFF',
        },
        danger: {
            '300': '#CF0000',
            '500': 'red',
            '600': '#FF0000',
            '800': '#FBF4F4'
        },
        warning: {
            '400': '#FAA50F',
            '500': '#fda952',
            '600': '#F3C51F',
            '700': '#FEF2DD',
            '800': '#FBF9F4',
        },
        success: {
            '200': '#1E4A24',
            '400': '#1AAB3A',
            '500': '#18ce18',
            '800': '#EBF9F1'
        },
        emerald: {
            '300': '#06D6A038',
            '500': '#06D6A0',
        },
        white: {
            '400': '#F6F9FB',
            '500': '#fff',
            '700': '#F4F4F4'
        },
    },
    sizes: {
        buttons: {
            paddings: {
                'xs': ['8px'],
                'sm': ['12px', '24px'],
                'md': ['15px', '40px'],
                'lg': ['13px', '70px'],
                'xl': ['20px', '80px']
            },
        },
        containers: {
            paddings: {
                'xs': ['15px'],
                'sm': ['20px', '24px'],
                'md': ['32px', '82px'],
                'lg': ['56px', '82px'],
                'xl': ['80px', '82px']
            },
        },
        inputs: {}
    },
    fontFamilies: {
        poppins: '--font-poppins'
    },
    fontSizes: {
        headline: {
            'xs': '16px',
            'sm': '20px',
            'md': '28px',
            'lg': '48px',
            'xl': '64px',
        },
        subtitle: {
            'xs': '14px',
            'sm': '20px',
            'md': '24px',
            'lg': '28px',
        },
        text: {
            'xs': '12px',
            'sm': '14px',
            'md': '20px',
            'lg': '24px',
            'xl': '28px',
        },
        button: {
            'xxs': '12px',
            'xs': '14px',
            'sm': '16px',
            'md': '18px',
            'lg': '22px',
            'xl': '24px',
        }
    },
    fontWeights: {
        '400': 400,
        '500': 500,
        '600': 600,
        '700': 700,
    },
    lineHeights: {
        headline: {
            'xs': '25px',
            'sm': '40px',
            'md': '50px',
            'lg': '60px',
            'xl': '80px',
        },
        subtitle: {
            'xs': '14px',
            'sm': '20px',
            'md': '24px',
            'lg': '30px',
            'xl': '40px',
        },
        text: {
            'xs': '20px',
            'sm': '30px',
            'md': '40px',
            'lg': '50px',
            'xl': '60px',
        }
    },
    letterSpacings: {
        'xs': '.1px',
        'sm': '.3px',
        'md': '.5px',
        'lg': '1.5px',
        'xl': '2px',
    },
    shadows: {
        primary: '0px 4px 20px rgba(74, 74, 74, 0.13)',
        secondary: '0px 0px 40px rgba(230, 45, 71, 0.03)'
    }
}
